import type { ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

import { LIST_LAYOUT } from './ListLayout';

type ListProps = {
  children: ReactNode;
};
interface ChildProps {
  variant?: any;
}

export function List({ children }: ListProps) {
  // const idxLayout = Math.min(Children.count(children), LIST_LAYOUTS.length);
  // const layout = LIST_LAYOUTS[idxLayout];
  const layout = LIST_LAYOUT;

  const childrenWithLayout = Children.map(children, (child, idx) => {
    if (isValidElement(child)) {
      return cloneElement(child, { variant: layout[idx % layout.length] } as ChildProps);
    }
    return child;
  });

  return (
    <div className="feed--list mb-4">
      <div className="grid grid-cols-6 gap-4">{childrenWithLayout}</div>
    </div>
  );
}
